module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Display#2-ae2884c08cd9936c9e1085ee94a06438.svg";